import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-37641d0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({ 'ellipsis-loader': true })
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "ellipsis-loader__dot",
      style: _normalizeStyle([_ctx.spinnerStyle])
    }, null, 4),
    _createElementVNode("div", {
      class: "ellipsis-loader__dot",
      style: _normalizeStyle([_ctx.spinnerStyle])
    }, null, 4),
    _createElementVNode("div", {
      class: "ellipsis-loader__dot",
      style: _normalizeStyle([_ctx.spinnerStyle])
    }, null, 4),
    _createElementVNode("div", {
      class: "ellipsis-loader__dot",
      style: _normalizeStyle([_ctx.spinnerStyle])
    }, null, 4)
  ]))
}